import React, { useLayoutEffect, useRef } from 'react';
import { useLocation, useNavigate, useRoutes } from 'react-router-dom';
import { Spinner, Flex } from '@chakra-ui/react';

import { publicRoutes } from './public';
import { getProtectedRoutesForRoles } from './getProtectedRoutesForRoles';
import { useAuth } from '@/context/AuthContext';
import { resolveReturnPath, splitReturnPath } from '@/utils/authRedirect';

export const AppRoutes = () => {

    const { user, authChecked } = useAuth();
    const location = useLocation();
    const navigate = useNavigate();
    const previousUserRef = useRef(user);
    const hasHandledPostLoginRedirectRef = useRef(false);
    const routes = user ? getProtectedRoutesForRoles(user.roles) : publicRoutes;

    const element = useRoutes([...routes]);

    useLayoutEffect(() => {
        if (!user) {
            hasHandledPostLoginRedirectRef.current = false;
            previousUserRef.current = user;
            return;
        }

        const didLogin = !previousUserRef.current && user;
        previousUserRef.current = user;

        if (!didLogin || hasHandledPostLoginRedirectRef.current) {
            return;
        }

        const returnPath = resolveReturnPath(location.search);
        if (!returnPath) {
            return;
        }

        const currentPath = `${location.pathname}${location.search}`;
        if (currentPath === returnPath) {
            return;
        }

        hasHandledPostLoginRedirectRef.current = true;
        const { pathname, search } = splitReturnPath(returnPath);
        navigate({ pathname, search }, { replace: true });
    }, [user, location.pathname, location.search, navigate]);

    if(!authChecked) {
        return (
            <Flex
                height={'full'}
                w={'full'}
                alignItems={'center'}
                justifyContent={'center'}
            >
                <Spinner size="xl" />
            </Flex>
        )
    }

    return <>{element}</>;
};
